import { apiCall } from '@/lib/api';
import { type PollImageUploadBody, requestPollImageUploadUrl } from '@uchat-team-management/shared';

export {
  addPollOption,
  closePoll,
  createPoll,
  deletePoll,
  getPoll,
  getPollIdBySlug,
  getPollResults,
  getPollViewerCandidates,
  getPollViewers,
  listPolls,
  publishPoll,
  replacePollViewers,
  respondToPoll,
  retractPollResponse,
  isAnswerableFieldType,
  toPollSlug,
  updatePoll,
} from '@uchat-team-management/shared';
export type {
  CreatePollBody,
  PollAnswer,
  PollAnswerValue,
  PollDetail,
  PollField,
  PollFieldConfig,
  PollFieldInput,
  PollFieldOption,
  PollFieldOptionInput,
  PollFieldResult,
  PollFieldType,
  PollListItem,
  PollResults,
  PollResultsVisibility,
  PollStatus,
  RespondToPollBody,
  UpdatePollBody,
} from '@uchat-team-management/shared';

/** Presign → PUT to storage; returns the storage path to save in the image element. */
export const uploadPollImage = async (file: File): Promise<string> => {
  const contentType = file.type as PollImageUploadBody['contentType'];
  const { data } = await apiCall(requestPollImageUploadUrl, {
    body: { contentType, sizeBytes: file.size },
  });
  const res = await fetch(data.presignedUrl, {
    method: 'PUT',
    headers: { 'Content-Type': contentType },
    body: file,
  });
  if (!res.ok) throw new Error('Image upload failed');
  return data.storagePath;
};

/** Copies the readable share link (`/to-polls/<slug>`) to the clipboard. */
export const copyPollLink = (slug: string): Promise<void> =>
  navigator.clipboard.writeText(`${window.location.origin}/to-polls/${slug}`);
